<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-03-06 16:54:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-22 18:46:42
-->
<template>
  <div>
    <van-tabs type="card" v-model="nowDateType" @click="onClickDateType">
      <van-tab
        v-for="(item, index) in dateTypeList"
        :key="index"
        :title="item.title"
        :name="item.type"
      ></van-tab>
    </van-tabs>
    <div v-if="nowDateType == 4" class="date_con">
      <p>{{ nowStartDate || "选择开始日期" }}</p>
      <span>-</span>
      <p>{{ nowEndDate || "选择结束日期" }}</p>
    </div>
    <van-calendar
      v-model="showDatePicker"
      :min-date="minDate"
      :max-date="maxDate"
      type="range"
      color="var(--tc)"
      :default-date="defaultDate"
      @confirm="onConfirmDate"
    />
  </div>
</template>

<script>
import { dateFormat } from "@/utils/index";
export default {
  name: "DateTabCom",
  props: {},
  data() {
    return {
      nowDateType: 0,
      dateTypeList: [
        { title: "今天", type: 0 },
        { title: "昨天", type: 1 },
        { title: "近7天", type: 2 },
        { title: "全部", type: 3 },
        { title: "自定义", type: 4 },
      ],
      showDatePicker: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      nowStartDate: "",
      nowEndDate: "",
      defaultDate: [],
    };
  },
  created() {},
  mounted() {
    this.defaultDate = [this.getLastDate(1), new Date()];
  },
  methods: {
    getLastDate(n) {
      var currentDate = new Date();
      var date = new Date(currentDate.getTime() - n * 24 * 3600 * 1000);
      return date;
    },
    onClickDateType(name, title) {
      console.log(name, title);
      this.nowDateType = name;
      if (name == 4) {
        this.showDatePicker = true;
      } else {
      }
      this.$emit("change", this.nowDateType);
    },
    onConfirmDate(date) {
      const [start, end] = date;
      this.showDatePicker = false;
      console.log(date);
      this.nowStartDate = dateFormat(start);
      this.nowEndDate = dateFormat(end);
      this.$emit("changeDate", [this.nowStartDate, this.nowEndDate]);
      // this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    },
  },
};
</script>
<style scoped lang="scss">
.date_con {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin: 0 20px;
  }
}
</style>
